// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { PortalBaseEntity } from '../portal-base-entity';
import { Job } from './job';
import { Practice } from './practice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BankAccountFeed extends PortalBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  applicationNumber?: string;
  authorityformLink?: string;
  bankCode?: string;
  bankId?: number;
  bankName?: string;
  bankfeedId?: string;
  bankfeedSourceJson?: string;
  bankfeedUid!: string;
  bsb?: string;
  completeOnline!: boolean;
  createdAt!: Date;
  createdBy!: string;
  currentStatus?: string;
  deleted!: boolean;
  finInstSource!: number;
  isActive!: boolean;
  jobId?: number;
  lastTransactionReceived?: string;
  practiceId!: number;
  serviceAssetId?: string;
  updatedAt!: Date;
  updatedBy!: string;
  version!: any;
  job!: Job;
  practice!: Practice;
}

